import { all } from 'redux-saga/effects';
import notificationsSagas from 'notifications/redux/notifications/sagas';
export default function* rootSaga(getState) {
    yield all([
        notificationsSagas(),
    ]);
}
